import React, { useEffect, useRef } from "react";


import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import CheckoutPage from "../CheckoutPage/";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));


const ContactModal = ({ open, onClose, Invoice, contactId, initialValues, onSave }) => {
  const classes = useStyles();
  const isMounted = useRef(true);


  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);


  const handleClose = () => {
    onClose();
  };

  return (
    <div className={classes.root}>
      <Dialog open={open} onClose={handleClose} maxWidth="md" scroll="paper">
        <DialogContent dividers>
          {Invoice?.manualOnly ? (
            <Box>
              <Typography variant="h5" gutterBottom>
                {i18n.t("financial.subscription.manualTitle")}
              </Typography>
              <Typography variant="body1" gutterBottom>
                {i18n.t("financial.subscription.selectedPlan")}: <strong>{Invoice.planName}</strong>
              </Typography>
              {typeof Invoice.value === "number" && (
                <Typography variant="body1" gutterBottom>
                  {i18n.t("financial.subscription.value")}:{" "}
                  <strong>
                    ${Invoice.value.toLocaleString("en-US", { minimumFractionDigits: 2 })}
                  </strong>
                </Typography>
              )}
              <Typography variant="body2" color="textSecondary" paragraph>
                {Invoice.manualPaymentInstructions ||
                  i18n.t("financial.subscription.manualDefault")}
              </Typography>
              {Invoice.manualPaymentEmail && (
                <Typography variant="body2" paragraph>
                  {i18n.t("financial.subscription.manualPaymentEmail")}:{" "}
                  <Link href={`mailto:${Invoice.manualPaymentEmail}`}>
                    {Invoice.manualPaymentEmail}
                  </Link>
                </Typography>
              )}
              {Invoice.manualPaymentWhatsapp && (
                <Typography variant="body2">
                  WhatsApp:{" "}
                  <Link
                    href={
                      Invoice.manualPaymentWhatsapp.startsWith("http")
                        ? Invoice.manualPaymentWhatsapp
                        : `https://wa.me/${String(Invoice.manualPaymentWhatsapp).replace(/\D/g, "")}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {Invoice.manualPaymentWhatsapp}
                  </Link>
                </Typography>
              )}
            </Box>
          ) : (
            <CheckoutPage
              Invoice={Invoice}
            />
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ContactModal;
